import {Component} from "@angular/core";
import {Field} from "../models/field.model";


@Component({
    selector: "tig-form-list",
    template: `
	    <div
			    class="form-group"
			    [formGroup]="OBJ_form_group"
			    [ngClass]="{'has-error': isInvalid()}">
		    <ng-template #tooltipTemplate>
			    <div [innerHtml]="getHint()|translate"></div>
		    </ng-template>
		    <label class="col-lg-2 control-label" [ngClass]="{'tgi-new': isNew()}">{{getLabelName()|translate}}
			    <i *ngIf="getHint()" class="fa fa-info-circle tig-tooltip-icon"
			       [tooltip]="tooltipTemplate"
			       placement="top"
			       triggers="click"
			       containerClass="tig-tooltip"
			       delay="50"></i> <span *ngIf="isRequired()" class="tgi-asterisk"> *</span></label>
		    <div class="col-lg-8">
			    <tig-tags-input
					    class="form-control"
					    [ngClass]="OBJ_field_config?.readonly?'tig-disabled':''"
					    [OBJ_field_config]="OBJ_field_config"
					    [formControlName]="OBJ_field_config.name"
					    (onTagsChanged)="handleChanged($event)"
					    [BOO_objectTags]="false"
					    [BOO_readonly]="OBJ_field_config?.readonly"
					    [STR_placeholder]="(OBJ_field_config?.placeholder||'oFormList.sAddNewTag')|translate"
					    [STR_secondaryPlaceholder]="'oFormList.sAddTag'|translate"
					    (onInputValidation)="handleValidation($event)"
			    ></tig-tags-input>
			    <span class="help-block m-b-none color-red" *ngIf="STR_validation_message.length > 0">{{ STR_validation_message | translate }}</span>
				<div class="tig-hint" *ngIf="OBJ_field_config.note">
					<span>{{ OBJ_field_config.note|translate}}</span>
				</div>
			    <tig-form-error [OBJ_form_control]="OBJ_form_group.get(OBJ_field_config.name)"></tig-form-error>
		    </div>
	    </div>
    `
})
export class FormListComponent extends Field
{


	/**
	 * @type {string}
	 */
	public STR_validation_message: string = '';


	/**
	 * Function > handleChanged
	 * @param {change: string, tag: string, tags: array} MIX_event
	 */
	handleChanged(MIX_event: {change: string, tag: string, tags: object})
	{
		// get form control and set value
		let OBJ_form_control = this.OBJ_form_group.get(this.OBJ_field_config.name);
		// set value to form control for correct validation
		OBJ_form_control.setValue(MIX_event.tags);
		// set value to fieldconfig
		this.setValue(MIX_event.tags);

		// mark es dirty and touched
		this.markAsDirtyAndTouched();

		// validate de values
		OBJ_form_control.updateValueAndValidity();

	} // end function handleChanged

	/**
	 * Function > handleValidation
	 * @param MIX_event
	 */
	handleValidation(MIX_event)
	{

		// get form control
		let OBJ_form_control = this.OBJ_form_group.get(this.OBJ_field_config.name);
		if (typeof MIX_event.count !== 'undefined' && this.isRequired())
		{

			this.STR_validation_message = '';
			if (MIX_event.count > 0)
			{
				OBJ_form_control.setErrors(null);
			}
			else
			{
				OBJ_form_control.setErrors({required: true});
			} // end if

		}
		else
		{
			this.STR_validation_message = MIX_event;
		} // end if

	} // end function handleValidation


} // end class FormInputComponent
